export default {
    legalEntities: [],
    numberOfNewInvoices: 0
};
